import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class Product {
  private url = environment.apiUrl;

  constructor(private httpClient: HttpClient) {}
  token: any = localStorage.getItem('token');
  headers: any;
  WHOLE_LIFE: any = 'WL';
  SAVING: any = 'SV';
  SHORT: any = 'ST';
  WHOLE_LIFE_OLD: any = 'P2301';
  RETIRE: any = 'RT';
  SAVING_OLD: any = 'P2302';

  findAllProducts() {
    // console.log('token' + this.token);

    this.headers = new HttpHeaders().set('Authorization', `Bearer ${this.token}`);

    return this.httpClient.get(`${this.url}/product`, { headers: this.headers });
  }

  findProductById(name: any) {
    // const token = localStorage.getItem('token');
    // console.log('token' + this.token);

    this.headers = new HttpHeaders({
      Authorization: `Bearer ${this.token}`,
    });
    return this.httpClient.get(`${this.url}/product/${name}`, { headers: this.headers });
  }

  findProductPlanById(name: any, subName: any) {
    this.headers = new HttpHeaders().set('Authorization', `Bearer ${this.token}`);
    return this.httpClient.get(`${this.url}/product/${name}/${subName}`, { headers: this.headers });
  }

  findProductOptionsById(name: any) {
    this.headers = new HttpHeaders().set('Authorization', `Bearer ${this.token}`);
    return this.httpClient.get(`${this.url}/product/plan/${name}/options`, {
      headers: this.headers,
    });
  }

  findAllProductsPlan() {
    this.headers = new HttpHeaders().set('Authorization', `Bearer ${this.token}`);
    return this.httpClient.get(`${this.url}/product/plans`, {
      headers: this.headers,
    });
  }

  findProductsPlanByProductId(name: any) {
    this.headers = new HttpHeaders().set('Authorization', `Bearer ${this.token}`);
    return this.httpClient.get(`${this.url}/product/plans?productId=${name}`, {
      headers: this.headers,
    });
  }
}
